"use strict";

var Uetd = function () {

  var set_vehicle_input_fields = function() {
    var contract_type = $("select[data-behaviour='contract-type-selection']").val();
    if (contract_type == "rented") {
      $("div[data-behaviour='rented_vehicle_fields']").show();
      $("div[data-behaviour='owned_vehicle_fields']").hide();
    } else {
      $("div[data-behaviour='rented_vehicle_fields']").hide();
      $("div[data-behaviour='owned_vehicle_fields']").show();
    }
  };

  var set_dep_city_and_region_inputs = function() {
    if ($('#uetd_line_dep_country_id').val() == "TR") {
      $('.uetd_line_dep_city_district_fields').show();
    } else {
      $('.uetd_line_dep_city_district_fields').hide();
    }
  };

  var set_arv_city_and_region_inputs = function() {
    if ($('#uetd_line_arv_country_id').val() == "TR") {
      $('.uetd_line_arv_city_district_fields').show();
    } else {
      $('.uetd_line_arv_city_district_fields').hide();
    }
  };

  var set_region_inputs = function(city_id, region_select_box_id) {
    $.ajax({
      type: "GET",
      url: "/regions",
      dataType: "script",
      data: {
        id: city_id,
        regions_select_id: region_select_box_id
      }
    });
  };

  var set_sender_infos = function() {
    $('#uetd_line_sender_name').val($('#uetd_line_sender_id').select2('data')[0]['name']);
    $('#uetd_line_sender_taxno').val($('#uetd_line_sender_id').select2('data')[0]['taxno']);
    $('#uetd_line_dep_country_id').val($('#uetd_line_sender_id').select2('data')[0]['country_id']).trigger('change');
    $('#uetd_line_dep_city_id').val($('#uetd_line_sender_id').select2('data')[0]['city_id']).trigger('change');
  }

  var set_consignee_infos = function() {
    $('#uetd_line_consignee_name').val($('#uetd_line_consignee_id').select2('data')[0]['name']);
    $('#uetd_line_consignee_taxno').val($('#uetd_line_consignee_id').select2('data')[0]['taxno']);
    $('#uetd_line_arv_country_id').val($('#uetd_line_consignee_id').select2('data')[0]['country_id']).trigger('change');
    $('#uetd_line_arv_city_id').val($('#uetd_line_consignee_id').select2('data')[0]['city_id']).trigger('change');
  }

  return {
    init: function () {
      $(document).on("change", "[data-behaviour='contract-type-selection']", function() {
        set_vehicle_input_fields();
      });
      set_vehicle_input_fields();

      $(document).on("change", "#uetd_line_dep_country_id", function() {
        Uetd.set_dep_city_and_region_inputs();
      });

      $(document).on("change", "#uetd_line_arv_country_id", function() {
        Uetd.set_arv_city_and_region_inputs();
      });

      $(document).on("change", "#uetd_line_dep_city_id", function() {
        Uetd.set_dep_region_inputs($(this).val());
      });

      $(document).on("change", "#uetd_line_sender_id", function() {
        Uetd.set_sender_infos($(this).val());
      });

      $(document).on("change", "#uetd_line_consignee_id", function() {
        Uetd.set_consignee_infos($(this).val());
      });

      $(document).on("change", "#uetd_line_arv_city_id", function() {
        Uetd.set_arv_region_inputs($(this).val());
      });
      Uetd.set_dep_city_and_region_inputs();
      Uetd.set_arv_city_and_region_inputs();
    },
    set_vehicle_input_fields: function () {
      set_vehicle_input_fields();
    },
    set_dep_city_and_region_inputs: function () {
      set_dep_city_and_region_inputs();
    },
    set_arv_city_and_region_inputs: function () {
      set_arv_city_and_region_inputs();
    },
    set_dep_region_inputs: function (city_id) {
      if (typeof city_id !== typeof undefined && city_id !== false && city_id != null && city_id != '') {
        set_region_inputs(city_id, "uetd_line_dep_district_id");
      }
    },
    set_arv_region_inputs: function (city_id) {
      if (typeof city_id !== typeof undefined && city_id !== false && city_id != null && city_id != '') {
        set_region_inputs(city_id, "uetd_line_arv_district_id");
      }
    },
    set_sender_infos: function (city_id) {
      set_sender_infos(city_id, "uetd_line_sender_id");
    },
    set_consignee_infos: function (city_id) {
      set_consignee_infos(city_id, "uetd_line_consignee_id");
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Uetd;
}
